import { useQueryClient } from '@tanstack/react-query'
import { useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApiError, NetworkError, api } from '../api/client.js'
import { Wordmark } from '../components/Logo.js'
import { Field, Notice } from '../components/ui.js'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api('/api/auth/login', { method: 'POST', body: { email, password } })
      await queryClient.invalidateQueries({ queryKey: ['session'] })
      navigate('/', { replace: true })
    } catch (err) {
      setError(
        err instanceof NetworkError
          ? 'Keine Verbindung zum Server.'
          : err instanceof ApiError
            ? err.message
            : 'Anmeldung fehlgeschlagen.',
      )
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="center-page">
      <div className="box">
        <div className="card">
          <div className="card-body">
            <div style={{ marginBottom: 22 }}>
              <Wordmark size={38} subtitle="Anmelden: Verwaltung und Kundenportal" />
            </div>

            {error && <Notice kind="error">{error}</Notice>}

            <form onSubmit={submit}>
              <Field label="E-Mail-Adresse">
                <input
                  type="email"
                  value={email}
                  autoComplete="username"
                  autoFocus
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>
              <Field label="Passwort">
                <input
                  type="password"
                  value={password}
                  autoComplete="current-password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Field>
              <button type="submit" className="btn block" disabled={busy}>
                {busy ? 'Wird geprüft …' : 'Anmelden'}
              </button>
            </form>
          </div>
        </div>
        <p className="muted small" style={{ textAlign: 'center', marginTop: 16 }}>
          Mitarbeiter melden sich über den Einladungslink an, den sie erhalten haben.
        </p>
      </div>
    </div>
  )
}
